module.exports = __webpack_public_path__ + "static/media/Active_Low_Frequency_Towed_Sonar_02.5bb869f9.jpg";